// ACTIONS
export const FETCH = 'offerzen/calendarStatus/FETCH'
export const FETCH_SUCCESS = 'offerzen/calendarStatus/FETCH_SUCCESS'

// ACTION CREATORS
export const fetch = id => ({
  type: FETCH,
  payload: id,
})

export const fetchSuccess = data => ({
  type: FETCH_SUCCESS,
  payload: data.result,
})

// REDUCERS
const initialState = {}

const calendarStatusReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUCCESS:
      return {
        ...state,
        ...action.payload,
      }

    default:
      return state
  }
}

export default calendarStatusReducer
